<template>
  <div class="homomorphic-encryption">
    <common-bg-plate>
      <change-chain></change-chain>
      <div v-show="hasContract" class="list-box">
        <action-bar>
          <btn-style :btn-list="btnList"></btn-style>
        </action-bar>
        <div v-for="(item, i) in list" :key="i" class="list-item">
          <div class="list-info">
            <div v-for="(ele, index) in showArr" :key="ele + index" class="item-line">
              <div class="item-label">{{ ele.label }}：</div>
              <div class="item-text">
                {{
                  ele.value == 'createdTime' ? formatTime(item[ele.value] * 1000) : item[ele.value]
                }}
              </div>
            </div>
          </div>
          <div class="list-operate">
            <el-button type="primary" class="detail-btn" @click="goDetail(item)"
              >查看详情</el-button
            >
            <!-- <el-button v-show="item.openStatus_open == 'open'  && openStatus_canClose == 'canClose'" type="primary" class="close-btn" @click="closeTask(item)">关闭任务</el-button>
            <el-button v-show="item.openStatus_open == 'open' && item.dataStatus_toJoin == 'tojoin'" type="primary" class="close-btn">参与任务</el-button> -->
          </div>
        </div>
        <!-- <div>
          <el-pagination
            ref="pagination"
            :page-size="paging.pageSize"
            :total="paging.total"
            :current-page="paging.pageNo"
            background
            layout="total, prev, pager, next, sizes, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div> -->
      </div>
      <div v-show="!hasContract" class="list-box">
        <no-contract @update:list="getContractStatus"></no-contract>
      </div>
    </common-bg-plate>
    <create-task ref="createTaskRef" @update:list="getList()"></create-task>
  </div>
</template>
<script>
import changeChain from './components/changeChain.vue'
import createTask from './components/createTask.vue'
import noContract from './components/homoNoContract.vue'
export default {
  components: {
    changeChain,
    createTask,
    noContract
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '新建隐私计算任务',
          click: () => {
            return this.createTask()
          }
        }
      ],
      paging: {
        pageNo: 1,
        pageSize: 10,
        total: 10
      },
      list: [],
      showArr: [
        { label: '数据名称', value: 'name' },
        { label: '创建时间', value: 'createdTime' },
        { label: '数据描述', value: 'description' }
      ],
      chainId: '',
      hasContract: false
    }
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.chainId = val
        this.getContractStatus()
      }
    }
  },
  mounted() {
    this.chainId = this.$store.state.computing.chainId
    if (this.chainId) {
      this.getContractStatus()
    }
  },
  methods: {
    getContractStatus() {
      let params = {
        chainId: this.chainId
      }
      this.$apis.privacy.getHasContract(params).then(res => {
        if (res.errors && res.errors[0].code == 40011) {
          this.hasContract = false
        } else {
          this.hasContract = true
          this.getList()
        }
      })
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    },
    getList() {
      this.$apis.privacy.getHomoList({ chainId: this.chainId }).then(res => {
        this.list = res.data
      })
    },
    createTask() {
      this.$refs.createTaskRef.handleOpen('homo')
    },
    goDetail(row) {
      this.$router.push({
        name: 'hTaskDetail',
        query: {
          taskId: row.taskId,
          chainId: this.chainId
        }
      })
    },
    handleSizeChange() {},
    handlePageChange() {}
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'homomorphic-encryption',
  (
    --homomorphic-encryption-body-item-border-color: #33496e,
    --homomorphic-encryption-body-item-label-color: rgba(255, 255, 255, 0.6),
    --homomorphic-encryption-body-item-text-color: #fff
  ),
  (
    --homomorphic-encryption-body-item-border-color: #ebebeb,
    --homomorphic-encryption-body-item-label-color: rgba(90, 105, 115, 1),
    --homomorphic-encryption-body-item-text-color: rgba(25, 34, 39, 1)
  )
);
.homomorphic-encryption {
  @include adaptation(
    (
      --homomorphic-encryption-top-bar-border-width: 1px,
      --homomorphic-encryption-body-padding: 24px 20px,
      --homomorphic-encryption-body-item-padding: 20px 20px 8px 16px,
      --homomorphic-encryption-body-item-margin-bottom: 12px,
      --homomorphic-encryption-body-item-operate-width: 175px,
      --homomorphic-encryption-body-item-font-size: 14px,
      --homomorphic-encryption-body-item-label-width: 70px,
      --homomorphic-encryption-body-item-operate-padding: 5px
    )
  );
  --homomorphic-encryption-min-height: var(--base-main-router-body-avaliable-height);
  color: var(--homomorphic-encryption-color);
  .common-bg-plate {
    min-height: var(--homomorphic-encryption-min-height);
    .list-box {
      padding: var(--homomorphic-encryption-body-padding);
      .list-item {
        padding: var(--homomorphic-encryption-body-item-padding);
        border: var(--homomorphic-encryption-top-bar-border-width) solid
          var(--homomorphic-encryption-body-item-border-color);
        margin-bottom: var(--homomorphic-encryption-body-item-margin-bottom);
        display: flex;
        .list-info {
          width: calc(100% - var(--homomorphic-encryption-body-item-operate-width));
          .item-line {
            display: flex;
            align-items: center;
            font-size: var(--homomorphic-encryption-body-item-font-size);
            margin-bottom: var(--homomorphic-encryption-body-item-margin-bottom);
            .item-label {
              width: var(--homomorphic-encryption-body-item-label-width);
              flex-shrink: 0;
              color: var(--homomorphic-encryption-body-item-label-color);
            }
            .item-text {
              flex: 1;
              color: var(--homomorphic-encryption-body-item-text-color);
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              padding-right: 1%;
            }
          }
        }
        .list-operate {
          flex-shrink: 0;
          width: var(--homomorphic-encryption-body-item-operate-width);
          padding-top: var(--homomorphic-encryption-body-item-operate-padding);
          text-align: right;
          // .detail-btn {
          //   border-top-right-radius: 0;
          //   border-bottom-right-radius: 0;
          // }
          .close-btn {
            margin-left: 0;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-left: 0;
          }
        }
      }
    }
  }
}
</style>
